import * as React from 'react';
import { reduxForm, Field, InjectedFormProps } from 'redux-form';
import { SpinnerOverlay } from '@weddingspot/ws-core-components';

import TextField from '../form/MaterialTextInput';
import { required, email } from '../../utils/validators';

const requiredValidation = (errorMessage: string): ((value: string | undefined) => undefined | string) => {
    return (value: string | undefined) => (required(value) ? errorMessage : undefined);
};

const requireName = requiredValidation('Please enter your full name to continue');
const validEmail = (value: string | undefined) => {
    if (!value) {
        return 'Please enter an email address to continue';
    }

    if (email(value)) {
        return 'Please enter a valid email address to continue';
    }

    return;
};

interface OwnProps {
    showUserSignupModal: () => void;
}

export interface FormData {
    name: string;
    email: string;
}

type AbandonmentFormProps = InjectedFormProps<FormData, OwnProps> & OwnProps;

class AbandonmentForm extends React.Component<AbandonmentFormProps, {}> {
    render() {
        const { error, handleSubmit, pristine, submitting } = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <div className='vendor-signup--abandonment--description'>
                    Just enter your name and email and you'll be on your way to creating your venue account.
                </div>
                <div className='vendor-signup--abandonment--fields'>
                    <Field name='name' label='Your name' component={TextField} validate={[requireName]} />
                    <Field name='email' label='Your email' type='email' component={TextField} validate={[validEmail]} />
                </div>
                <div className='vendor-signup--abandonment--cta'>
                    <a className='vendor-signup--abandonment--usersignup' href={undefined} onClick={this.props.showUserSignupModal}>
                        I'm not a venue
                    </a>
                    <SpinnerOverlay
                        isSpinning={submitting}
                        spinnerProps={{
                            spinnerDiameter: 30,
                        }}
                    >
                        <button
                            type='submit'
                            className='vendor-signup--abandonment--submit nx-button nx-button--primary'
                            disabled={pristine || submitting}
                        >
                            I'm in!
                        </button>
                    </SpinnerOverlay>
                    {error && <div className='vendor-signup--abandonment--form-level-error'>{error}</div>}
                </div>
            </form>
        );
    }
}

export default reduxForm<FormData, OwnProps>({
    form: 'AbandonmentForm',
    asyncBlurFields: [],
})(AbandonmentForm);
